import axios from 'axios';
import authHeader from './auth-header';
import RetryPolicy from './RetryAuthProblems'

const API_URL = process.env.REACT_APP_API_URL;
const axiosApiInstanceForValidation = axios.create();

axiosApiInstanceForValidation.interceptors.response.use(response => {
    return response;
}, async error => RetryPolicy(error));

class ClientContractsService {

    getClientContracts(ClientId) {
        return axiosApiInstanceForValidation.get(API_URL + '/V3/Clients/' + ClientId + '/Contracts', { headers: authHeader() });
    }

    getClientContractsFiltered(clientId, filter, orderBy, page, pageSize) {

        let filterToSend = "";

        if (orderBy)
            filterToSend = orderBy;


        if (page)
            if (filterToSend !== "")
                filterToSend += "&page=" + page;
            else
                filterToSend = "?page=" + page;

        if (pageSize)
            if (filterToSend !== "")
                filterToSend += "&pageSize=" + pageSize;
            else
                filterToSend = "?pageSize=" + pageSize;

        if (filter)
            if (filterToSend !== "")
                filterToSend += "&filter=" + filter;
            else
                filterToSend = "?filter=" + filter;

        return axiosApiInstanceForValidation.get(API_URL + '/V3/Clients/' + clientId + '/Contracts' + filterToSend, { headers: authHeader() });
    }

    getClientContract(ClientId, ContractId) {
        return axiosApiInstanceForValidation.get(API_URL + '/V3/Clients/' + ClientId + '/Contracts/' + ContractId, { headers: authHeader() });
    }


    getClientContractLicenses(ClientId, ContractId) {
        return axiosApiInstanceForValidation.get(API_URL + '/V3/Clients/' + ClientId + '/Contracts/' + ContractId +'/Licenses', { headers: authHeader() });
    }

    saveClientContractLicense(ClientId, ContractId, LicenseId) {
        return axiosApiInstanceForValidation.put(API_URL + '/V3/Clients/' + ClientId + '/Contracts/' + ContractId +'/Licenses/' + LicenseId, {}, { headers: authHeader() });
    }

    deleteClientContractLicense(ClientId, ContractId, LicenseId) {
        return axiosApiInstanceForValidation.delete(API_URL + '/V3/Clients/' + ClientId + '/Contracts/' + ContractId +'/Licenses/' + LicenseId, { headers: authHeader() });
    }

    deleteClientContract(ClientId, ContractId) {
        return axiosApiInstanceForValidation.delete(API_URL + '/V3/Clients/' + ClientId + '/Contracts/' + ContractId, { headers: authHeader() });
    }

    updateClientContract(ClientId, ContractId, ClientContract) {
        return axiosApiInstanceForValidation.put(API_URL + '/V3/Clients/' + ClientId + '/Contracts/' + ContractId, ClientContract, { headers: authHeader() });
    }

    insertClientContract(ClientId, ClientContract) {
        return axiosApiInstanceForValidation.post(API_URL + '/V3/Clients/' + ClientId + '/Contracts', ClientContract, { headers: authHeader() });
    }
}

export default new ClientContractsService();
